import { whatsAppUrl } from '@/config'
import { CLIENT_EDIT_PREFERENCE } from '@/resources/enums/orders'
import { ActiveOrder, OrderEditOptions } from '@/resources/types'
import { OrderDetails } from '@/resources/types/orderDetails'
import {
  getOnlinePaymentText,
  isOnlinePayment,
} from '@/services/orders/payment'
import { ORDERS_PAGE as dict, EDIT_ORDER as dictEdit } from '@/resources/dict'

export const getWhatsappMessageForEditedOrder = (
  updatedOrder: OrderDetails | ActiveOrder,
  name: string
) => {
  const greetingMessage =
    dict.sendMessageToClientModal.whatsappMessage.title.replace(
      dict.sendMessageToClientModal.nameOfStore,
      name
    )

  const orderNumberMessage =
    dict.sendMessageToClientModal.whatsappMessage.deliveryOrder.replace(
      dict.sendMessageToClientModal.orderNumber,
      updatedOrder.number
    )

  const deliveryMessage = dict.sendMessageToClientModal.whatsappMessage.delivery

  const itemsList = updatedOrder.items
    .map(item => `*${item.amount}x ${item.name}*`)
    .join('\n')

  let reassuranceMessage =
    dict.sendMessageToClientModal.whatsappMessage.dontWorry

  const paymentType = updatedOrder.payment[0].type

  if (isOnlinePayment(paymentType)) {
    const type = getOnlinePaymentText(paymentType)
    reassuranceMessage = `${dict.sendMessageToClientModal.whatsappMessage.dontWorryOnlinePayment.replace('%type', type)}`
  }

  return [
    greetingMessage,
    '',
    orderNumberMessage,
    '',
    deliveryMessage,
    itemsList,
    '',
    reassuranceMessage,
  ].join('\n')
}

const getWhatsappMessage = (sellerName: string, orderNumber: string) => {
  return dictEdit.alert.whatsappMessage
    .replace('%STORE_NAME', sellerName)
    .replace('%ORDER_NUMBER', orderNumber)
}

export const openWhatsappUrlForEditModal = (
  phoneNumber: string,
  sellerName: string,
  orderNumber: string
) => {
  const formatPhone = phoneNumber.replaceAll(/\D/g, '')
  const message = encodeURIComponent(
    getWhatsappMessage(sellerName, orderNumber)
  )
  const fullUrl = `${whatsAppUrl}${formatPhone}?text=${message}`
  window.open(fullUrl, '_blank')
}

export const shouldContactClient = (
  clientPreference: CLIENT_EDIT_PREFERENCE | null
) => !clientPreference || clientPreference === CLIENT_EDIT_PREFERENCE.ASK_CLIENT

export const getClientPreferenceMessage = (
  clientPreference: CLIENT_EDIT_PREFERENCE | null
) => {
  let message = dictEdit.alert.clientPreference
  switch (clientPreference) {
    case CLIENT_EDIT_PREFERENCE.REPLACE_ITEM:
      message += dictEdit.alert.replace
      break
    case CLIENT_EDIT_PREFERENCE.DELETE_ITEM:
      message += dictEdit.alert.delete
      break
    case CLIENT_EDIT_PREFERENCE.ASK_CLIENT:
    default:
      message = dictEdit.alert.text
  }
  return message
}

export const getClientPreferenceFromEditOptions = (
  editOptions: OrderEditOptions | null
): CLIENT_EDIT_PREFERENCE => {
  if (
    !editOptions ||
    !Object.values(CLIENT_EDIT_PREFERENCE).includes(editOptions.option)
  ) {
    return CLIENT_EDIT_PREFERENCE.ASK_CLIENT
  }

  return editOptions.option
}

export const getCustomerPreferenceForAnalytics = (
  editOptions: OrderEditOptions | null | undefined
): string | null => {
  const preference = getClientPreferenceFromEditOptions(editOptions ?? null)
  switch (preference) {
    case CLIENT_EDIT_PREFERENCE.REPLACE_ITEM:
      return dictEdit.analytics.customerPreference.replaceItem
    case CLIENT_EDIT_PREFERENCE.DELETE_ITEM:
      return dictEdit.analytics.customerPreference.removeItem
    default:
      return null
  }
}
